module.exports = __webpack_public_path__ + "img/Costel.1e32a4f0.png";